<template lang="pug">
  v-row(
    align="center" 
    no-gutters
  ).mt-0.container-card.pa-1
    v-row(no-gutters).mt-4
      v-col.pa-1(
        v-if="!showGame"
        v-for='(item, i) in gameCategories'
        :key='i'
        cols=4
        sm=3
        md=2
        lg=1
      ) 
        v-card(
          class="toolbartab"
          height="100%"
          :disabled='item.is_closed'
          @click="currentSubTypeId = item.id"
        ).d-flex.justify-center
          v-img(
            v-if="item.image_url"
            cover
            center
            height="100%"
            aspect-ratio="1"
            :src='item.image_url' 
          )

          v-img(
            v-if="!item.image_url"
            width="80%"
            aspect-ratio="1"
            src='@/assets/v3/logo-fav.png'
          )

      v-col.pa-1(
        v-if="showGame"
        v-for='(item, i) in items'
        :key='i'
        cols=4
        sm=3
        md=2
        lg=1
      ) 
        v-card(
          class="toolbartab"
          height="100%"
          :disabled='item.is_closed'
          @click='gotoExternalGame(item.id,item.name,item.category_game_type_id)'
        )
          v-img(
            cover
            center
            height="100%"
            aspect-ratio="1"
            :src=' item.is_external ? item.image_url : externalGamePath(item.id)' 
          )
    dialog-game-format(@select="onSelectGameFormat" ref="dialoggameformat")
</template>
<script>
import { service as apiExternal } from '@/apis'       
import { IsInternalApp } from '@/plugins/checkType'
import { externalGamePath } from '@/plugins/mapImage'
import { ROUTE_INTERNAL_LOTTO, ROUTE_POWER_BALL } from '@/const/route'
import { isGameTypeIdSeamless } from '@/const/gameId'
import DialogGameFormat from '@/views-v2/Index/child/DialogGameFormat'

const MOBILE = 'mobile'
const DESKTOP = 'desktop'

const ALL = 0
const LOTTO = 1
const CASINO = 2
const SPORT = 3
const SLOT = 4
const POWER_BALL = 5
const EXTERNALTAB = [
  { id: CASINO, name: 'casino',icon:require('@/assets/nav/submenu/icon_submenu2.svg'), 'color': '#EDAE50' },
  { id: SPORT, name: 'sport',icon:require('@/assets/nav/submenu/icon_submenu16.svg'), 'color': '#708AF7' },
  { id: SLOT, name: 'slot',icon:require('@/assets/nav/submenu/icon_submenu15.svg'), 'color': '#C8495C' },
  { id: POWER_BALL, name: 'powerball',icon:require('@/assets/nav/submenu/icon_power_ball.svg'), 'color': '#f1e03c' },
]

export default {
  components: {
    DialogGameFormat
  },
  props: {
    currentTypeId: {
      type: Number,
      default: null
    },
    resetState: {
      type: String,
      default: null
    }
  },
  data: () => ({
    currentSubTypeId: null
  }),
  computed: {
    MOBILE: () => MOBILE,
    DESKTOP: () => DESKTOP,
    title () {
      return EXTERNALTAB.find(x => x.id == this.currentTypeId).name
    },
    subTitle () {
      return this.externalGame.find(x => x.id === this.currentSubTypeId)?.name
    },
    externalGame () {
      return this.$store.getters['externalGame/GETTERS_EXTERNALGAME']
    },
    bgColor () {
       return EXTERNALTAB.find(x => x.id == this.currentTypeId).color
    },
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    },
    showGame () {
      return this.currentSubTypeId != null;
    },
    gameCategories () {
      return this.externalGame.filter(x => x.category_game_type_id == this.currentTypeId)
    },
    items () {
  
      let externalItems = this.externalGame.filter(x => x.category_game_type_id == this.currentTypeId)
      
      externalItems = this.currentSubTypeId == null ? externalItems : externalItems.filter(x => x.id == this.currentSubTypeId)

      // HARD CODE FOR INTERNAL GAME LOTTO GROUP
      let extractedGames = [];

      externalItems.forEach(function (item) {
        var games = item.games.map(function (game) {
          game.is_external = true;

          return game;
        })

         extractedGames = extractedGames.concat(games);
      });

      extractedGames.sort((a, b) => {
        if (a.order_priority !== null && b.order_priority !== null) {
          if (a.order_priority !== b.order_priority) {
              return a.order_priority - b.order_priority;
          }
        } else if (a.order_priority !== null && b.order_priority === null) {
            return -1;
        } else if (a.order_priority === null && b.order_priority !== null) {
            return 1;
        }

        if (a.game_type_id !== null && b.game_type_id !== null) {
          if (a.game_type_id !== b.game_type_id) {
              return a.game_type_id - b.game_type_id;
          }
        } else if (a.game_type_id !== null && b.game_type_id === null) {
            return -1;
        } else if (a.game_type_id === null && b.game_type_id !== null) {
            return 1;
        }

        return a.id - b.id;
      });

      return [...extractedGames];
    },
  },
  
  watch: {
    currentTab () {
      this.currentSubtab = ALL
    },
    resetState () {
      this.currentSubTypeId = null;
    }
  },
  async mounted () {
  },
  methods : { 
    externalGamePath,
    async topUp (id) {
      if(isGameTypeIdSeamless(id)) {
        return
      }
      const [err] = await apiExternal.postTransfer(id)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      } 
    }, 

    isIOS () {
      return /MacIntel/.test(navigator.platform)  && navigator.maxTouchPoints && navigator.maxTouchPoints > 2
    },

    async endpoint (id) {
      if (this.gameFormat) {
        return this.gameFormat == MOBILE ? apiExternal.getLoginGameMobile(id) : apiExternal.getLoginGameDesktop(id)
      }

      let isIpad = this.isIOS()
      return isIpad ? apiExternal.getLoginGameMobile(id) : apiExternal.getLoginGame(id) 
    },

    async onSelectGameFormat (value) {
      this.gameFormat = value
      const { id, name, category_game_type_id } = this.gameParams;
      
      await this.gotoExternalGame(id, name, category_game_type_id);
    },

    async gotoExternalGame (id, name, category_game_type_id) {  
      //only lotto game to route page
      if(category_game_type_id === LOTTO) {
        this.$router.push({
          name: ROUTE_INTERNAL_LOTTO
        })
        return
      }
      
      if(category_game_type_id === POWER_BALL) {
        this.$router.push({
          name: ROUTE_POWER_BALL
        })
        return
      }

      if (this.currentTab == SPORT && this.gameFormat == null) {
        this.gameParams = { id, name, category_game_type_id }
        this.$refs.dialoggameformat.open()
        return
      }
      let windowReference = IsInternalApp() ? window : window.open() ; 

      const [err,data,message] = await this.endpoint(id)

      this.gameFormat = null
      
      if(err) {
        windowReference.close()
        this.$alert('',err,'warning') 
        return
      }

      if(data && data.redirect_to) {
        // await this.topUp(id) 
        this.$store.dispatch('userProfile/ACTION_WALLET') 
        windowReference.location = data.redirect_to   
      } else {
        windowReference.close()
        this.$alert('',message,'warning')
      }  

      this.$ga.event('Button', 'GotoExternalgame', 'CasinoPage-V2',name )  
    },  
  }
}
</script>
<style scoped>
.container-card {
  border-radius: 18px;
}

.game-title {
  font-size: 22px;
}

.back-btn {
  height: 30px !important;
  cursor: pointer;
  box-shadow: unset;
}

.toolbartab {
  border-radius: 20px;
  background-color: unset !important;
  box-shadow: unset;
}

@media only screen and (max-width: 1264px) {
  .toolbartab {
    border-radius: 30px;
  }
}

@media only screen and (max-width: 900px) {
  .toolbartab {
    border-radius: 24px;
  }
}
</style>